<!-- Header section -->
<login-header></login-header>

<!-- Hero section -->
<div class="lp_hero gradient_bg" style="background-image: url('/assets/images/contact-bg.webp');">
    <div class="lp_hero_content d-grid align-items-center">
        <div class="lp_hero_text">
            <h1 class="lp_h1 mb-5 text-capitalize">Connect your family and Your most valuable information.</h1>
            <p class="mb-5 lp_p">Family Central provides the tools and support to plan for life’s day-to-day needs, important milestones, and inevitable emergencies and death all in one place.</p>
            <a routerLink="/questionnaires" class="primary_btn">Sign up</a>
        </div>
        <div class="lp_hero_image">
            <img class="w-100 d-none d-md-block" fetchpriority="high" src="/assets/images/families-hero.webp" alt="">
            <img class="w-100 d-block d-md-none" fetchpriority="high" src="/assets/images/families-hero.webp" alt="">
        </div>
    </div>
</div>

<div class="fc_tools">
    <div class="px-90 m-auto">
        <div class="tools_content d-md-grid align-items-center">
            <div class="tools_image text-center">
                <img src="/assets/images/round-photo.webp" alt="" loading="lazy">
            </div>
            <div class="tools_text">
                <h2 class="lp_h2 mb-5">Tools that help and connect you and the most important people in your life.</h2>
                <p class="lp_p mb-0">Family Central is always at your fingertips and you can trust that your important information is always secure and easily shared with your family when you need to the most.</p>
            </div>
        </div>
    </div>
</div>

<div class="lp_features">
    <div class="px-90 m-auto text-center">
        <div class="features_list d-md-grid">
            <div class="single_feature">
                <div class="feature_img mb-3">
                    <img src="/assets/images/vault-blue.svg" width="64" height="64" alt="" loading="lazy">
                </div>
                <h3 class="lp_h3 mb-3">Private Personal Vault</h3>
                <p class="lp_p">Store private documents and information</p>
            </div>
            <div class="single_feature">
                <div class="feature_img mb-3">
                    <img src="/assets/images/legacy-circle-blue.svg" width="64" height="64" alt="" loading="lazy">
                </div>
                <h3 class="lp_h3 mb-3">Private Legacy Videos</h3>
                <p class="lp_p">Create videos as legacy communication for your loved ones</p>
            </div>
            <div class="single_feature">
                <div class="feature_img mb-3">
                    <img src="/assets/images/files-icon-blue.svg" alt="" width="62" height="57" loading="lazy">
                </div>
                <h3 class="lp_h3 mb-3">Family File Sharing</h3>
                <p class="lp_p">Access and share  important documents with the entire family </p>
            </div>
        </div>
    </div>
</div>

<div class="everything_place gradient_bg" style="background-image: url('/assets/images/contact-bg.webp');">
    <div class="px-90 m-auto">
        <div class="everything_content d-lg-grid align-items-center">
            <div class="everything_text">
                <h2 class="lp_h2 text-capitalize">Everything in the right place</h2>
                <p class="mb-5 lp_p">With Family Central, you can have all of your most important information at your fingertips, from making sure the kids make it to soccer on time to protecting your family’s legacy for generations to come.</p>
                <a routerLink="/questionnaires" class="border_btn red_border">Start your free trial</a>
            </div>
            <div class="everything_circle_carousel">
                <!-- Feature Carousel -->
                <div id="featureCarousel" class="carousel slide carousel-fade features_carousel" data-bs-ride="carousel"
                data-bs-interval="1000">
                <!-- Indicators/dots -->
                <div class="carousel-indicators menu">
                    <button type="button" name="link" data-bs-target="#featureCarousel" data-bs-slide-to="0" class="active btn"
                        aria-label="Photo sharing icon">
                        <img class="default_icon" src="/assets/images/gallery-icon.svg" alt="Photo sharing icon ">
                        <img class="active_icon" src="/assets/images/gallery-icon-red.svg" alt="Photo sharing icon">
                        <span class="btn_txt">Photo sharing</span>
                    </button>
                    <button type="button" name="link" data-bs-target="#featureCarousel" data-bs-slide-to="1" class="btn" aria-label="GPS icon">
                        <img class="default_icon" src="/assets/images/hp-gps.svg" alt="GPS icon">
                        <img class="active_icon" src="/assets/images/hp-gps-red.svg" alt="GPS icon">
                        <span class="btn_txt">GPS</span>
                    </button>
                    <button type="button" name="link" data-bs-target="#featureCarousel" data-bs-slide-to="2" class="btn"
                        aria-labelledby="Files icon">
                        <img class="default_icon" src="/assets/images/hp-folder.svg" alt="Files icon">
                        <img class="active_icon" src="/assets/images/hp-folder-red.svg" alt="Files icon">
                        <span class="btn_txt">Files</span>
                    </button>
                    <button type="button" name="link" data-bs-target="#featureCarousel" data-bs-slide-to="3" class="btn"
                        aria-label="Personal Vault icon">
                        <img class="default_icon" src="/assets/images/hp-safebox.svg" alt="Personal Vault icon">
                        <img class="active_icon" src="/assets/images/hp-safebox-red.svg" alt="Personal Vault icon">
                        <span class="btn_txt">Personal Vault</span>
                    </button>
                    <button type="button" name="link" data-bs-target="#featureCarousel" data-bs-slide-to="4" class="btn"
                        aria-labelledby="Legacy Messages">
                        <img class="default_icon" src="/assets/images/hp-playbtn-new.svg" alt="Legacy Messages icon">
                        <img class="active_icon" src="/assets/images/hp-playbtn-red.svg" alt="Legacy Messages icon">
                        <span class="btn_txt">Legacy Messages</span>
                    </button>
                    <button type="button" name="link" data-bs-target="#featureCarousel" data-bs-slide-to="5" class="btn"
                        aria-labelledby="For 8 Family Members">
                        <img class="default_icon" src="/assets/images/hp-fam.svg" alt="For 8 Family Members icon">
                        <img class="active_icon" src="/assets/images/hp-fam-red.svg" alt="For 8 Family Members icon">
                        <span class="btn_txt">For 8 Family Members</span>
                    </button>
                    <button type="button" name="link" data-bs-target="#featureCarousel" data-bs-slide-to="6" class="btn"
                        aria-labelledby="Calendar">
                        <img class="default_icon" src="/assets/images/hp-cal.svg" alt="Calendar icon">
                        <img class="active_icon" src="/assets/images/hp-cal-red.svg" alt="Calendar icon">
                        <span class="btn_txt">Calendar</span>
                    </button>
                    <button type="button" name="link" data-bs-target="#featureCarousel" data-bs-slide-to="7" class="btn"
                        aria-labelledby="Emergency Contacts">
                        <img class="default_icon" src="/assets/images/hp-contct.svg" alt="Emergency contact icon">
                        <img class="active_icon" src="/assets/images/hp-contct-red.svg" alt="Emergency contact icon">
                        <span class="btn_txt">Emergency Contacts</span>
                    </button>
                </div>

                <!-- The slideshow/carousel -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <div class="single_featuree">
                            <div class="feature_app_screen">
                                <img src="/assets/images/everything-carousel-image.webp" alt="Photo in phone image">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="single_featuree">
                            <div class="feature_app_screen">
                                <img src="/assets/images/everything-carousel-image.webp" alt="GPS in phone image">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="single_featuree">
                            <div class="feature_app_screen">
                                <img src="/assets/images/everything-carousel-image.webp" alt="Files in phone image">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="single_featuree">
                            <div class="feature_app_screen">
                                <img src="/assets/images/everything-carousel-image.webp" alt="Personal vault in phone image">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="single_featuree">
                            <div class="feature_app_screen">
                                <img src="/assets/images/everything-carousel-image.webp" alt="Legacy video folder in phone image">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="single_featuree">
                            <div class="feature_app_screen">
                                <img src="/assets/images/everything-carousel-image.webp" alt="Family folder in phone image">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="single_featuree">
                            <div class="feature_app_screen">
                                <img src="/assets/images/everything-carousel-image.webp" alt="Calendar in phone image">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="single_featuree">
                            <div class="feature_app_screen">
                                <img src="/assets/images/everything-carousel-image.webp" alt="Emergency folder in phone image">
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="preparing_death">
    <div class="px-90 m-auto">
        <div class="preparing_death_content d-md-grid align-items-center">
            <div class="preparing_death_text">
                <h2 class="lp_h2 mb-3 mb-lg-5 text-capitalize">Preparing for your death is an act of love</h2>
                <p class="lp_p mb-3">You can take steps today to take care of your loved one even after your passing. </p>
                <p class="lp_p mb-3 mb-lg-5">You can record stories to preserve your family history; be part of special milestones that happen after you are gone (such as a child's birthday or wedding); and share your last wishes with your loved ones to help them navigate a terrible and overwhelming time.</p>
            </div>
            <div class="preparing_death_img text-center text-md-end">
                <img src="/assets/images/photo-panel.webp" alt="" loading="lazy">
            </div>
        </div>
    </div>
</div>

<!-- Technology and Security architecture-->
<div class="technology_section gradient_bg" style="background-image: url('/assets/images/contact-bg.webp');">
    <div class="px-90 m-auto">
        <div class="technology_content d-md-grid align-items-center">
            <div class="technology_image">
                <img class="w-100" src="/assets/images/technology-image.webp" alt="" loading="lazy">
            </div>
            <div class="technology_text">
                <h2 class="lp_h2 text-capitalize">Technology and Security architecture</h2>
                <h3 class="lp_h3">Your important information is always safe.</h3>
    
                <div class="partners_details mt-5">
                    <div class="single_partner mb-5">
                        <img class="mb-3" src="/assets/images/wowrack-logo.svg" width="234" height="40" alt="" loading="lazy">
                        <p class="lp_p">Wowrack.com provides our infrastructure services, private hosting and cloud infrastructure with bank encrypted levels of security.</p>
                    </div>
                    <div class="single_partner mb-5">
                        <img class="mb-3" src="/assets/images/microsoft-azure-logo.webp" width="234" height="33" alt="" loading="lazy">
                        <p class="lp_p">Azure.microsoft.com provide Family Central with data protection through 256-bit AES standard and encryption on our applications and services at their global data centers.</p>
                    </div>
                    <div class="single_partner">
                        <img class="mb-3" src="/assets/images/arctic-logo.webp" width="158" height="56" alt="" loading="lazy">
                        <p class="lp_p mb-0">Arcticwolf.com provides 24/7 monitoring detection, risk management and proactive security posture for global  fortune 100  companies and Family Central.  </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="ask_anything mb-5">
    <div class="px-90 m-auto">
        <div class="ask_anything_top text-center mb-5">
            <h2 class="lp_h2 text-capitalize">Ask us anything</h2>
            <p class="lp_p">We are always here to answer your questions.</p>
            <p class="lp_p">or <a routerLink="/contactus" class="text_red">Contact Us.</a></p>
        </div>
        <div class="ask_anything_tabs">
            <div class="ask_tabs_accordion" id="professionalsAccordion">
                <div class="card">
                    <div class="card-header">
                        <a class="btn" data-bs-toggle="collapse" href="#proQuestion1" aria-expanded="true">How much does Family Central cost?</a>
                    </div>
                    <div id="proQuestion1" class="collapse show" data-bs-parent="#professionalsAccordion">
                        <div class="card-body lp_p">
                            Family Central offers a free 14 days trial period for subscribers. For a family (up to 8 members, including the subscriber), the subscriber pays $199 annually for one year or $299 annually for two years. Your subscription includes 250 GB of storage. If additional family members are needed, the add-on fee is $99 annually for an additional 8 family members. If additional storage is needed, the add-on fee $99 for an addition 250 GB of storage.
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion2">
                            Can I cancel at any time?
                        </a>
                    </div>
                    <div id="proQuestion2" class="collapse" data-bs-parent="#professionalsAccordion">
                        <div class="card-body lp_p">
                            If a client chooses to cancel their subscription, they will be given 30 days to move the data to an alternate storage location.  After 30 days, we will delete all data from our records. 
                        </div>
                    </div>
                </div>

            
                
                <div class="card">
                    <div class="card-header">
                        <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion4">
                            Can I use Family Central on any device?
                        </a>
                    </div>
                    <div id="proQuestion4" class="collapse" data-bs-parent="#professionalsAccordion">
                        <div class="card-body lp_p">
                            Yes!  You can download the Family Central app to your phone.  We recommend iOS 13 or newer or Android 9 or newer operating systems to best support the Family Central app.
                        </div>
                    </div>
                </div>
                
                <div class="card">
                    <div class="card-header">
                        <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion5">
                            Is my information safe?
                        </a>
                    </div>
                    <div id="proQuestion5" class="collapse" data-bs-parent="#professionalsAccordion">
                        <div class="card-body lp_p">
                            At the core of Family Central’s functionality is its security. Our commitment to each and every family member is to keep their personal information safe and secure.  Family Central uses bank-level encryption technology, is SOC 2 compliant, HIPAA compliant, GDPR ready,
CCPA ready, and registered with Dun & Bradstreet. Microsoft Azure.com provides our data protection through AES-256 encryption on our applications and services at their global data centers, and Artic Wolf provides 24/7 monitoring detection, risk management, and 
proactive security posture for Family Central, as well as global Fortune 100 companies.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="get_started_section">
    <div class="px-90 m-auto">
        <div class="get_started_content d-grid align-items-center">
            <div class="get_started_image">
                <img class="w-100" src="/assets/images/coworkers-watching-a-macbook-mockup-sitting-on-a-sofa.webp" alt="" loading="lazy">
            </div>
            <div class="get_started_box">
                <h2 class="h2 mb-4 text-capitalize">Are you ready to get started with Family Central?</h2>
                <form [formGroup]="emailForm">
                    <div class="form-group get_started_field">
                        <input type="email" name="email" id="email" class="form-control" placeholder="Enter your email address" formControlName="email">
                        <button type="submit" class="primary_btn" (click)="goToOnboard()">Sign up</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<!-- Footer section -->
<app-footer></app-footer>